import {
    BILLING_STATEMENT__FETCHING,
    BILLING_STATEMENT__FAILED,
    BILLING_STATEMENT__SUCCESS,
} from "../actions/types";
  

  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case BILLING_STATEMENT__FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case BILLING_STATEMENT__FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case BILLING_STATEMENT__SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }